import { MarketingDrawer } from '@app/components/general'
import { metaSetter } from '@app/utils'
import { SectionContainer } from '@app/components/stateless/containers/section-container'
import {
  Header,
  Header2,
  Header3,
  Header4,
} from '@app/components/general/header'
import { Paragraph } from '@app/components/stateless/typo/paragraph'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import Trans from 'next-translate/Trans'
import { Address } from '@app/components/general/mailto'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'
import { blueLink } from '@app/components/stateless/typo/link-style'
import { SUPPORT_EMAIL } from '@app/configs/app-config'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/consulting',
    }),
  }
}

function Consulting() {
  const { t } = useTranslation('consulting')

  return (
    <MarketingDrawer>
      <SectionContainer container block>
        <Header>{t('header')}</Header>
        <Paragraph>{t('header-d')}</Paragraph>
        <Header2>{t('legal')}</Header2>
        <Paragraph>{t('legal-d')}</Paragraph>
        <Header3>{t('support')}</Header3>
        <Paragraph>{t('support-d')}</Paragraph>
        <ul className='space-y-2 py-2 list-disc px-4'>
          {[0, 1, 2, 3, 4].map((_, i) => (
            <li key={`support-list-${i}`}>{t(`support-list.${i}`)}</li>
          ))}
        </ul>
        <Header4>{t('custom')}</Header4>
        <ul className='space-y-2 py-2 list-disc px-4'>
          {[0, 1, 2].map((_, i) => (
            <li key={`custom-list-${i}`}>{t(`custom-list.${i}`)}</li>
          ))}
        </ul>

        <Trans
          i18nKey='consulting:more'
          components={[
            <Paragraph key={'c1'} />,
            <Address email={SUPPORT_EMAIL} className={blueLink} key={'c2'} />,
          ]}
        />
      </SectionContainer>
    </MarketingDrawer>
  )
}

export default metaSetter(
  { Consulting },
  {
    translation: 'consulting',
  }
)
